module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/39.2d3b2c50.png";